import './inject/injectWindowRequestAnimationFrame';
import { StrictMode, startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { StartClient } from '@tanstack/react-start/client';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import Config from '../config';
import { initTheme } from './hooks/useTheme';
import '../public/commander-scss/main.scss';
import '../public/styles/tailwind.css';

// Client entry of TanStack Start (vite.config.ts `client.entry`). The server renders the
// document (client/routes/__root.tsx) and this hydrates it.

initTheme();

const NODE_ENV_PRODUCTION = 'production';

// A tab that stayed open during a deployment can still request a lazy chunk
// from the previous build. Prefix the original error so TanStack Router does
// not classify it as a module-not-found error and invoke its own automatic
// reload. The error still propagates to the router error boundary.
window.addEventListener('vite:preloadError', (event: Event) => {
  const error = (event as Event & { payload?: unknown }).payload;
  if (error instanceof Error) {
    error.message = `CCC chunk load failed: ${error.message}`;
  }

  // Automatic recovery is intentionally disabled because it could discard an
  // unsaved form. It can be enabled once form state is persisted safely.
  // event.preventDefault();
  // window.location.reload();
});

if (process.env.NODE_ENV === NODE_ENV_PRODUCTION) {
  Sentry.init({
    dsn: Config.Sentry.dns,
    integrations: [new BrowserTracing()],
    environment: Config.Sentry.environment,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

if (process.env.NODE_ENV === NODE_ENV_PRODUCTION) {
  disableReactDevTools();
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <StartClient />
    </StrictMode>
  );
});
